const headers = [
  {
    id: 'clientName',
    numeric: true,
    disablePadding: false,
    label: 'Client',
    sortable: true,
  },
  {
    id: 'campaignName',
    numeric: true,
    disablePadding: false,
    label: 'Campaign Name',
    sortable: true,
  },
  {
    id: 'week',
    numeric: true,
    disablePadding: false,
    label: 'Week',
    sortable: true,
  },
  {
    id: 'date',
    numeric: true,
    disablePadding: false,
    label: 'Date',
    sortable: true,
  },
  {
    id: 'time',
    numeric: true,
    disablePadding: false,
    label: 'Time',
    sortable: true,
  },
  {
    id: 'timeOfDay',
    numeric: true,
    disablePadding: false,
    label: 'Time of day',
    sortable: true,
  },
  {
    id: 'dayOfWeek',
    numeric: true,
    disablePadding: false,
    label: 'Day of week',
    sortable: true,
  },
  {
    id: 'canBeSpied',
    numeric: true,
    disablePadding: false,
    label: 'Can be spied',
    sortable: false,
  },
  {
    id: 'spy',
    numeric: true,
    disablePadding: false,
    label: 'Spy',
    sortable: false,
  },
  {
    id: 'location',
    numeric: true,
    disablePadding: false,
    label: 'Location',
    sortable: true,
  },
  {
    id: 'brandAmbassador',
    numeric: true,
    disablePadding: false,
    label: 'BA',
    sortable: true,
  },
  {
    id: 'flyerCode',
    numeric: true,
    disablePadding: false,
    label: 'Code',
    sortable: true,
  },
  {
    id: 'tag',
    numeric: true,
    disablePadding: false,
    label: 'Tag',
    sortable: false,
  },
  {
    id: 'flyersDistributed',
    numeric: true,
    disablePadding: false,
    label: 'Flyer distributed',
    sortable: true,
  },
  {
    id: 'scans',
    numeric: true,
    disablePadding: false,
    label: 'Scans',
    sortable: false,
  },
  {
    id: 'metric1',
    numeric: true,
    disablePadding: false,
    label: 'Metric I',
    sortable: false,
  },
  {
    id: 'metric2',
    numeric: true,
    disablePadding: false,
    label: 'Metric II',
    sortable: false,
  },
  {
    id: 'status',
    numeric: true,
    disablePadding: false,
    label: 'Status',
    sortable: true,
  },
  {
    id: 'rating',
    numeric: true,
    disablePadding: false,
    label: 'Rating',
    sortable: true,
  },
]

const presets = [
  { id: 'noPresets', label: 'No Preset' },
  { id: 'liveMissions', label: 'Live Missions' },
  { id: 'yesterdayMissions', label: "Yesterday's missions" },
  { id: 'todayMissions', label: "Today's missions" },
  { id: 'tomorrowMissions', label: "Tomorrow's missions" },
]

const defaultModalState = {
  text: '',
  shiftId: null,
  isOpen: false,
  type: null,
  canBeSpied: null,
  missionId: null,
}

const MODAL_TYPES = {
  UPDATE_MISSION: 'UPDATE_MISSION',
  DELETE_SPY: 'DELETE_SPY',
}

export { headers, presets, defaultModalState, MODAL_TYPES }



// WEBPACK FOOTER //
// ./src/Containers/City/Page/MasterSchedule/options.js